// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"hIwjuSYpACIxm5LDUogI1"};